import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-31675a82"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "legal-page" }
const _hoisted_2 = { class: "section legal-page__hero" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Rechtliches", -1))
const _hoisted_4 = { class: "section legal-page__body" }
const _hoisted_5 = { class: "legal-page__content" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("h1", null, _toDisplayString(_ctx.content.title), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.content.intro), 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.content.sections, (section) => {
        return (_openBlock(), _createElementBlock("section", {
          key: section.title,
          class: "legal-page__section"
        }, [
          _createElementVNode("h2", null, _toDisplayString(section.title), 1),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.paragraphs, (paragraph) => {
              return (_openBlock(), _createElementBlock("p", {
                key: paragraph.text
              }, [
                _createTextVNode(_toDisplayString(paragraph.text) + " ", 1),
                (paragraph.link)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      href: paragraph.link.href,
                      target: "_blank",
                      rel: "noopener noreferrer"
                    }, _toDisplayString(paragraph.link.label), 9, _hoisted_6))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      }), 128))
    ])
  ]))
}